// @ts-expect-error type not available yet
import HardDeleteThreadPrompt from 'conversations-thread-view/thread-deletion/components/HardDeleteThreadPrompt';
import { hardDeleteThread } from 'conversations-thread-data/thread-actions/public/actions';
import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getUpdatedConversation } from 'conversations-thread-view/usage-tracking/utils/threadInteraction';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteThreadPrompt = ({
  originalGenericChannelId,
  ticket,
  threadId,
  showDeleteThreadPrompt,
  setDeleteThreadPrompt
}) => {
  const dispatch = useDispatch();
  const deleteThread = () => {
    setDeleteThreadPrompt(false);
    trackEvent(getUpdatedConversation({
      genericChannelId: originalGenericChannelId,
      updateType: 'hard delete'
    }));
    dispatch(hardDeleteThread({
      threadId
    }));
    if (ticket) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.alerts.ticket-updates.permanently-deleted"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.alerts.titles.success"
        }),
        type: 'success'
      });
    }
  };
  if (!showDeleteThreadPrompt) return null;
  return /*#__PURE__*/_jsx(HardDeleteThreadPrompt, {
    onConfirm: deleteThread,
    onReject: () => setDeleteThreadPrompt(false),
    ticket: ticket
  });
};
DeleteThreadPrompt.displayName = 'DeleteThreadPrompt';
export default DeleteThreadPrompt;